define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/Configuration',
	'internal_util/OpeneCardUtil',
	'internal_util/ClientUtil',
	'model/EidClient',
	'model/AuthenticationOption',
	'model/AuthenticationOptionGroup',
	'service/EidClientEventManager',
	'amdi18n-loader?!model/eidclient/nls/OpeneCardApp_strings',
	'lib/jquery'
], function (
	Logger,
	Util,
	Configuration,
	OpeneCardUtil,
	ClientUtil,
	EidClient,
	AuthenticationOption,
	AuthenticationOptionGroup,
	EidClientEventManager,
	Strings,
	jQuery
) {
	'use strict';

	function OpeneCardApp() {
		var _id = 'http://ws.skidentity.de/oi/go/client/OpeneCardApp',
			_name = 'Open eCard App',
			_baseAddress = 'http://127.0.0.1:24727/',
			_eventManager = new EidClientEventManager(),
			_appName = null,
			_appVersion = null,
			_supportedCardsProtocols = OpeneCardUtil.supportedCardsProtocols,
			_simulateDetection = false,
			_waitForChangeMaxRetries = 3,
			_appStarted = false,
			_ifds = new Array(),
			_xhr;

		EidClient.call(this, _id);


		// private methods

		function log(method, message, data) {
			Logger.log(_name, method, message, data);
		}

		function find(namespace, parent, element) {
			return jQuery(parent[0].getElementsByTagNameNS(namespace, element));
		}

		function parseConnectionHandle(connectionHandle) {
			var namespace = 'urn:iso:std:iso-iec:24727:tech:schema',
				result = {},
				recognitionInfo = find(namespace, connectionHandle, 'RecognitionInfo');
				//channelHandle = find(namespace, connectionHandle, 'ChannelHandle');

			result['contextHandle'] = find(namespace, connectionHandle, 'ContextHandle').text();

			/*if (!Util.isValidString(result['contextHandle'])) {
				throw new Error('OpeneCardApp.parseConnectionHandle(): invalid connection handle, ' +
						'no context handle found');
			}*/

			if (recognitionInfo.length !== 0) {
				result['cardType'] = find(namespace, recognitionInfo, 'CardType').text();

				/*if (!Util.isValidString(result['cardType'])) {
					throw new Error('OpeneCardApp.parseConnectionHandle(): invalid connection handle, ' +
							'no card type found');
				}*/
			}

			result['ifdName'] = find(namespace, connectionHandle, 'IFDName').text();

			if (!Util.isValidString(result['ifdName'])) {
				result['ifdName'] = 'NO_IFD_NAME';
			}

			result['slotIndex'] = find(namespace, connectionHandle, 'SlotIndex').text();

			if (!Util.isValidString(result['slotIndex'])) {
				result['slotIndex'] = 'NO_SLOT_INDEX';
			}

			/*if (channelHandle.length !== 0) {
				result['channelHandle'] = find(namespace, channelHandle, 'SessionIdentifier').text();
			}*/

			return result;
		}

		function parseStatusXML(data) {
			var namespace = 'http://ws.openecard.org/schema',
				result = {},
				status = find(namespace, data, 'Status'),
				userAgent = find(namespace, status, 'UserAgent'),
				supportedCards = find(namespace, status, 'SupportedCards'),
				connectionHandles = find(namespace, status, 'ConnectionHandle'),
				cardType,
				protocols,
				i, j;

			result['eidClientName'] = find(namespace, userAgent, 'Name').text();
			result['eidClientVersion'] = find(namespace, userAgent, 'VersionMajor').text() + '.'
					+ find(namespace, userAgent, 'VersionMinor').text() + '.'
					+ find(namespace, userAgent, 'VersionSubminor').text();

			result['supportedCardsProtocols'] = {};

			for (i = 0; i < supportedCards.length; i++) {
				supportedCards[i] = jQuery(supportedCards[i]);

				cardType = find(namespace, supportedCards[i], 'CardType').text();
				protocols = find(namespace, supportedCards[i], 'DIDProtocols');

				result['supportedCardsProtocols'][cardType] = new Array();

				for (j = 0; j < protocols.length; j++) {
					result['supportedCardsProtocols'][cardType].push(jQuery(protocols[j]).text());
				}
			}

			result['connectionHandles'] = new Array();

			for (i = 0; i < connectionHandles.length; i++) {
				result['connectionHandles'].push(parseConnectionHandle(jQuery(connectionHandles[i])));
			}

			return result;
		}

		function parseStatusChangeXML(data) {
			var namespace = 'http://ws.openecard.org/schema',
				result = {},
				statusChange = find(namespace, data, 'StatusChange');

			result['action'] = find(namespace, statusChange, 'Action').text();
			result['connectionHandle'] = parseConnectionHandle(find(namespace, statusChange, 'ConnectionHandle'));

			return result;
		}

		function sendEvent(statusChange) {
			var event = {
				type : OpeneCardUtil.translateEventType(statusChange['action'])
			};

			switch (event.type) {
			case 'TERMINAL_ADDED':
				_ifds.push(statusChange['connectionHandle']['ifdName']);

				event.data = {
					id : Util.generateId(statusChange['connectionHandle']['ifdName']),
					name : statusChange['connectionHandle']['ifdName'],
					contextHandle : statusChange['connectionHandle']['contextHandle']
				};
				break;
			case 'TERMINAL_REMOVED':
				_ifds.splice(_ifds.indexOf(statusChange['connectionHandle']['ifdName']), 1);

				event.data = {
					id : Util.generateId(statusChange['connectionHandle']['ifdName'])
				};
				break;
			case 'CARD_INSERTED':
			case 'CARD_RECOGNIZED':
				event.data = {
					id : Util.generateId(statusChange['connectionHandle']['ifdName']) + '-' +
							statusChange['connectionHandle']['slotIndex'],
					type : statusChange['connectionHandle']['cardType'],
					slot : statusChange['connectionHandle']['slotIndex'],
					terminalId : Util.generateId(statusChange['connectionHandle']['ifdName'])
				};
				break;
			case 'CARD_REMOVED':
				event.data = {
					id : Util.generateId(statusChange['connectionHandle']['ifdName']) + '-' +
							statusChange['connectionHandle']['slotIndex'],
					terminalId : Util.generateId(statusChange['connectionHandle']['ifdName'])
				};
				break;
			default:
				log('sendEvent', Strings.unknown_event, statusChange.action);
			}

			if (event.hasOwnProperty('data')) {
				_eventManager.handleEvent(event);
			}
		}

		function generateEventsStatusChange(statusChange) {
			var cardType = statusChange['connectionHandle']['cardType'];

			statusChange['action'] = 'http://openecard.org/event/terminal_added';
			sendEvent(statusChange);

			statusChange['action']  = 'http://openecard.org/event/card_inserted';
			statusChange['connectionHandle']['cardType'] = 'http://bsi.bund.de/cif/unknown';
			sendEvent(statusChange);

			if (cardType !== 'http://bsi.bund.de/cif/unknown') {
				statusChange['action']  = 'http://openecard.org/event/card_recognized';
				statusChange['connectionHandle']['cardType'] = cardType;
				sendEvent(statusChange);
			}
		}

		function generateEventsStatus(status) {
			for (var i = 0; i < status['connectionHandles'].length; i++) {
				generateEventsStatusChange({'connectionHandle' : status['connectionHandles'][i]});
			}
		}

		function waitForChange(session, retryCount) {
			if (!_appStarted) {
				return;
			}

			_xhr = jQuery.ajax({
				url: Configuration.get('OPEN_ECARD_APP_STATUS_URL') + '/waitForChange?session=' + session,
				dataType: 'xml',
				timeout: 0,
				cache : false,
				success: function (data) {
					var statusChange = parseStatusChangeXML(jQuery(data));

					if (_ifds.indexOf(statusChange['connectionHandle']['ifdName']) === -1) {
						generateEventsStatusChange(statusChange);
					} else {
						sendEvent(statusChange);
					}

					waitForChange(session);
				},
				error: function (jqXHR, textStatus) {
					if (textStatus === 'timeout') {
						waitForChange(session);
					} else {
						if (retryCount < _waitForChangeMaxRetries) {
							waitForChange(session, (typeof retryCount === 'undefined' ? 0 : ++retryCount));
						} else {
							_appStarted = false;
							_ifds = new Array();
							log('waitForChange', Strings.wait_for_change_failed, jqXHR);
						}
					}
				}
			});
		}


		// public methods

		this.name = function () {
			return _name;
		};

		this.supportsPlatform = function () {
			return !ClientUtil.isMobileClient();
		};
		//TODO: always true, check eCard App if latest (#950)
		this.supportsAuthenticationOption = function (authenticationOption) {
			/*
			var authenticationOptions,
				i;

			if (authenticationOption instanceof AuthenticationOption) {
				authenticationOptions = [ authenticationOption ];
			} else if (authenticationOption instanceof AuthenticationOptionGroup) {
				authenticationOptions = authenticationOption.authenticationOptions();
			} else {
				return false;
			}

			for (i = 0; i < authenticationOptions.length; i++) {
				if (!_supportedCardsProtocols.hasOwnProperty(authenticationOptions[i].type())) {
					return false;
				}
			}
				*/
			//Always true (#852)
			return true;
		};

		this.supportsStatus = function () {
			return true;
		};

		this.enableDetection = function () {
			_simulateDetection = true;
		};

		this.disableDetection = function () {
			_simulateDetection = false;
		};

		this.detect = function (callbacks, errorCallbacks) {
			var _name = 'detect';

			log(_name, Strings.detection_started);

			if (!_simulateDetection) {
				jQuery.ajax({
					url : Configuration.get('OPEN_ECARD_APP_STATUS_URL') + '/getStatus',
					cache : false,
					timeout : Configuration.get('OPEN_ECARD_APP_COMMUNICATION_TIMEOUT'),
					dataType : 'xml',
					success : function () {
						log(_name, Strings.detection_successful);
						Util.callCallbacks(callbacks);
					},
					error: function (jqXHR) {
						log(_name, Strings.detection_failed, jqXHR);
						Util.callCallbacks(errorCallbacks);
					}
				});
			} else {
				log(_name, Strings.detection_successful);
				Util.callCallbacks(callbacks);
			}
		};

		this.start = function (callbacks, errorCallbacks) {
			var _name = 'start',
				session;

			if (_appStarted) {
				return;
			}

			_appStarted = true;
			session = Util.randomString();

			log(_name, Strings.communication_started);

			_xhr = jQuery.ajax({
				url : Configuration.get('OPEN_ECARD_APP_STATUS_URL') + '/getStatus?session=' + session,
				cache : false,
				dataType : 'xml',
				timeout : Configuration.get('OPEN_ECARD_APP_COMMUNICATION_TIMEOUT'),
				success : function (data) {
					var statusXML = parseStatusXML(jQuery(data));

					_appName = statusXML['eidClientName'];
					_appVersion = statusXML['eidClientVersion'];
					_supportedCardsProtocols = statusXML['supportedCardsProtocols'];

					log(_name, Strings.communication_successful, {
								name : _appName,
								version : _appVersion,
								supportedCardsProtocols : _supportedCardsProtocols
							});

					generateEventsStatus(statusXML);
					waitForChange(session);

					Util.callCallbacks(callbacks);
				},
				error : function (jqXHR) {
					_appStarted = false;
					log(_name, Strings.communication_failed, jqXHR);
					Util.callCallbacks(errorCallbacks);
				}
			});
		};

		this.stop = function (/*callbacks, errorCallbacks*/) {
			if (!_appStarted) {
				return;
			}

			_appStarted = false;
			_ifds = new Array();

			_xhr.abort();

			log('stop', Strings.communication_stopped);
		};

		this.activate = function (authenticationOption, tcTokenURL, callbacks) {
			var eidClientUrl = _baseAddress + 'eID-Client?',
				authenticationOptions,
				i;

			if (authenticationOption instanceof AuthenticationOptionGroup) {
				authenticationOptions = authenticationOption.authenticationOptions();

				eidClientUrl += 'cardTypes=';

				for (i = 0; i < authenticationOptions.length; i++) {
					if (i > 0) {
						eidClientUrl += ',';
					}

					eidClientUrl += encodeURIComponent(authenticationOptions[i].type())
				}
			} else {
				eidClientUrl += 'cardType=' + encodeURIComponent(authenticationOption.type());
			}

			eidClientUrl += '&tcTokenURL=' + encodeURIComponent(tcTokenURL);

			Util.callCallbacks(callbacks);
			ClientUtil.redirectTo(eidClientUrl);
		};

		this.toObject = function () {
			return _name;
		};
	}

	OpeneCardApp.prototype = Object.create(EidClient.prototype);

	return OpeneCardApp;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/eidclient/OpeneCardApp.js
// module id = 282
// module chunks = 2